// @flow
import React, { Component } from 'react'
// $FlowFixMe
import { Field, FormSection, reduxForm } from 'redux-form'
import { Button, GreenPattern, StyledP, Title, YellowPattern } from 'src/theme/globalStyle'
import { getContent, priority, getThreshold } from './helpers'
import {
  Check,
  Details,
  FieldCollection,
  FormField,
  Label,
  PaymentDetails,
  StyledArticle,
  StyledForm,
  StyledFormPage
} from 'src/components/Form'
import { renderError, renderField, renderRadio } from 'src/helpers/fieldRenderers'
import { normalizeGBP } from 'src/helpers/normalize'
import { required } from 'src/helpers/validation'
import { PaymentOptions } from 'src/components/PaymentOptions'
import { NavBar } from 'src/components/NavBar'
import { BookingInfo } from 'src/components/BookingInfo'
import { ArrowDown, ArrowUp, LoadingCircle } from 'src/components/Icons'

import Oops from 'src/containers/SecureRoom/components/Oops'
import TickIcon from 'src/assets/icons/check-single.svg'
import {
  IconRow,
  Icon,
  IconLabel,
  IconLabelPriceBold,
  IconLabelBold,
  NewFlex,
  NewTitle,
  RadioBox,
  SuperStyledRadioBox,
  SuperStyledRadio,
  StyledOption,
  OptionHeading,
  OptionLabel,
  OptionList,
  PlanButtonWrapper,
  StyledPlanButton,
  SelectButtonText,
  StyledA,
  StyledCheckbox,
  StyledButton,
  LoadingContainer
} from './StyledElements'
import PleaseNoteText from './components/PleaseNoteText'
import { ShowGurantorText } from './components/GurantorText'
import { TandCRibbon } from './components'
import type { PaymentDeets, Props, State } from './types'
import { validate } from './validationHelper'
import StickyMobileHeader from './components/MobileHeader/StickyMobileHeader'
import PaymentModal from './components/MobileHeader/PaymentModal'

class SecureRoomFormComponent extends Component<Props, State> {
  paymentDetails: ?PaymentDeets
  termsSection: Object
  _isMounted = false
  state = {
    showTerms: false,
    checkButton: false,
    showGuarantor: false,
    showCardPayment: true,
    readyForPayment: false,
    processingStep: 1
  }
  toggleTerms = (evt: Object, open?: Boolean) => {
    const { showTerms } = this.state
    this.setState({
      showTerms: open ? true : !showTerms
    })
    if (open) {
      setTimeout(() => this.termsSection.scrollIntoView(), 50)
    } else {
      evt.preventDefault()
    }
  }
  componentDidMount() {
    this._isMounted = true
  }

  componentWillUnmount() {
    this._isMounted = false
  }
  UNSAFE_componentWillMount() {
    const { adminFee, bookingDeposit } = this.props
    const fee = adminFee ? parseInt(adminFee, 10) : 0
    const deposit = bookingDeposit ? parseInt(bookingDeposit, 10) : 0
    if (fee + deposit === 0) {
      this.setState({ showCardPayment: false })
    }
  }

  _onChangePaymentPlan = (e: Object, value: string) => {
    const { income, booking } = this.props
    const val = `${income}`.replace('£', '')
    const myIncome = Math.round((booking.membership.weeklyPrice * 104) / 1000) * 1000
    const isAffordable = parseInt(val, 10) > myIncome
    if (!isAffordable && value === 'monthly_2_weeks_security_guarantor') {
      this.setState({ showGuarantor: true })
    } else {
      this.setState({ showGuarantor: false })
    }
  }
  _onChangePaymentMethod = (e: Object, value: string) => {
    if (value === 'cash') {
      this.setState({ showCardPayment: false })
    } else {
      this.setState({ showCardPayment: true })
    }
  }
  _isAffordable = () => {
    const { income, booking } = this.props
    const val = `${income}`.replace('£', '')
    const myIncome = Math.round((booking.membership.weeklyPrice * 104) / 1000) * 1000
    return parseInt(val, 10) >= myIncome
  }
  _onBlurSalary = (e: Object) => {
    const { change, booking } = this.props
    const val = `${e.target.value}`.replace('£', '')
    let income = Math.round((booking.membership.weeklyPrice * 104) / 1000) * 1000
    const result = parseInt(val, 10) < income
    change('isAffordable', !result)
    change('paymentPlan', '')
  }
  // $FlowFixMe
  displayIcons = (...items) => {
    const content = getContent(this.props.booking.membership.weeklyPrice)
    return items.map(item => (
      <IconRow key={item}>
        <Icon>
          <img src={content[item].icon} alt={content[item].label} />
        </Icon>
        <IconLabel>
          {item === 'rent2weeks' || item === 'rent5weeks' ? (
            <span>
              {content[item].prelabel}
              <IconLabelPriceBold>{content[item].label} </IconLabelPriceBold>
              <IconLabelBold>security bond&nbsp;</IconLabelBold>
              {content[item].postlabel}
            </span>
          ) : (
            content[item].label
          )}
        </IconLabel>
      </IconRow>
    ))
  }

  _onPaymentSuccess = (paymentIntent: any) => {
    this.setState({ processingStep: 3 })
    const { handleSubmit, addPaymentIntent } = this.props
    // Trigger paymentIntent
    addPaymentIntent && addPaymentIntent(paymentIntent)
    handleSubmit()
    if (this._isMounted) {
      this.setState({ readyForPayment: false })
    }
  }
  _onPaymentError = (error: any) => {
    //dispatch the error to oops page with error :: payment was not successful
    const { stripeError } = this.props

    this.setState({ readyForPayment: false })
    stripeError(error)
  }
  handleSubmit = (e: Object) => {
    e.preventDefault()
    e.stopPropagation()
    const {
      handleSubmit,
      adminFee,
      bookingDeposit,
      showLoader,
      formFull = {},
      allow_cash
    } = this.props
    const { values = {} } = formFull
    const { member = {} } = values
    const fee = adminFee ? parseInt(adminFee, 10) : 0
    let focusTriggered = false
    const deposit = bookingDeposit ? parseInt(bookingDeposit, 10) : 0

    if (
      !member.firstName ||
      !member.lastName ||
      (!this.state.showCardPayment && allow_cash) ||
      (!this.state.showCardPayment && fee + deposit === 0)
    ) {
      handleSubmit()
    }

    const { syncErrors } = formFull
    if (syncErrors && syncErrors.member) {
      priority.forEach(p => {
        if (syncErrors.member[p]) {
          const ele = document.querySelector(`input[name="member.${p}"]`)
          if (ele && !focusTriggered) {
            ele.parentElement && ele.parentElement.scrollIntoView
              ? // $FlowFixMe
                ele.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
              : ele.focus()
            focusTriggered = true
          }
        }
      })
    }
    if (syncErrors) {
      priority.forEach(p => {
        if (syncErrors[p]) {
          const ele = document.querySelector(`input[name="${p}"]`)
          if (ele && !focusTriggered) {
            ele.parentElement && ele.parentElement.scrollIntoView
              ? // $FlowFixMe
                ele.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
              : ele.focus()
            focusTriggered = true
          }
        }
      })
    }

    if (focusTriggered) {
      handleSubmit()
      // make sure input shows error in case of submit
    }
    if (
      this.paymentDetails &&
      this.state.showCardPayment &&
      !focusTriggered &&
      !this.isButtonDisabled()
    ) {
      if (this.paymentDetails._complete === true) {
        // show loader spinner to disable form
        showLoader && showLoader()
        // Trigger paymentIntent
        this.setState({ readyForPayment: true, processingStep: 1 })
      } else {
        focusTriggered = true
        this.paymentDetails.focus()
      }
    }
  }
  checkIt = () => {
    // this.setState({ checkButton: !this.state.checkButton })
    this.setState((prevState: State) => ({ checkButton: !prevState.checkButton }))
  }
  isButtonDisabled = () => {
    const { formFull } = this.props
    if (
      formFull &&
      formFull.anyTouched &&
      ((this.paymentDetails && this.paymentDetails._complete === true) ||
        !this.state.showCardPayment)
    ) {
      if ((formFull.syncErrors && formFull.syncErrors.member) || formFull.syncErrors) {
        if (formFull.values.terms === true) {
          return false
        }
        return true
      }
      return false
    }
    if (
      formFull &&
      !formFull.syncErrors &&
      !this.state.showCardPayment &&
      formFull.values.terms === true
    ) {
      return false
    }
    return true
  }
  render() {
    const {
      booking,
      bookingDeposit,
      adminFee,
      paymentPlan,
      isProcessing,
      allow_cash,
      formFull = {},
      locationId
    } = this.props
    const { showTerms, showGuarantor, showCardPayment } = this.state
    const { values = {} } = formFull
    const { member = {} } = values
    if (!booking.room) {
      return (
        <Oops
          canGoBack={false}
          title="Oh, hello there!"
          message="Unfortunately you can't refresh the page you were on, because for security reasons we have to clear the form to protect your data. Please start over by using the link you were provided for this reservation. "
        />
      )
    }
    const { occupancyType } = booking
    const income = Math.round((booking.membership.weeklyPrice * 104) / 1000) * 1000
    const fee = adminFee ? parseInt(adminFee, 10) : 0
    const deposit = bookingDeposit ? parseInt(bookingDeposit, 10) : 0
    const isActuallyAffordable = this._isAffordable()
    // const monthlyFee = Math.round((booking.membership.weeklyPrice * 52) / 12)
    const { overThreshold, underThreshold } = getThreshold()
    const plansForThreshold = isActuallyAffordable ? overThreshold : underThreshold
    const showPayment = (showCardPayment || !allow_cash) && locationId && deposit + fee !== 0

    return (
      <StyledFormPage>
        <StickyMobileHeader
          booking={booking}
          paymentPlan={paymentPlan || 'monthly'}
          bookingDeposit={bookingDeposit}
          adminFee={adminFee}
        />
        <NavBar title={'Room Application'} />
        <YellowPattern />
        <GreenPattern />
        <StyledArticle>
          <StyledForm onSubmit={this.handleSubmit}>
            <FieldCollection hasShadow>
              <Title>Personal Information</Title>
              <FormSection name="member">
                <Details isFull={true} />
              </FormSection>
              {booking.location.studentEnabled && (
                <FormField noBorder={true}>
                  <Label>Are you a Student?</Label>
                  <RadioBox id="student">
                    <Field
                      name="isStudent"
                      component={renderRadio}
                      fixedValue="Yes"
                      required
                      validate={[required]}
                      label="Yes"
                    />
                    <Field
                      name="isStudent"
                      component={renderRadio}
                      required
                      validate={[required]}
                      fixedValue="No"
                      label="No"
                    />
                  </RadioBox>
                  <Field name="isStudent" hideArrow component={renderError} />
                </FormField>
              )}
            </FieldCollection>
            {occupancyType === 'double' && (
              <FieldCollection hasShadow>
                <Title>Your Partner&apos;s Details</Title>
                <FormSection name="partner">
                  <Details isPartner />
                </FormSection>
              </FieldCollection>
            )}
            <FieldCollection hasShadow>
              <Title lessMargin>Income Check</Title>
              <StyledP>
                We&apos;re asking for your annual income as part of our affordability criteria.
              </StyledP>
              <Field
                name="income"
                label={
                  occupancyType === 'double'
                    ? 'What is your combined annual income for you and your partner?'
                    : 'What is your annual income?'
                }
                secondLabel="(In Great British Pounds)"
                type="text"
                altError="annual income"
                normalize={normalizeGBP}
                onChange={this._onBlurSalary}
                component={renderField}
                required
                validate={[required]}
                placeholder="£0.00"
              />
              <FormField noBorder={true}>
                <Label>Select your membership payment plan</Label>
                <SuperStyledRadioBox>
                  {plansForThreshold.map((planItem, index) => (
                    <SuperStyledRadio
                      key={planItem.plan}
                      isSelected={paymentPlan === planItem.plan ? true : false}
                      id={`label-${planItem.id}`}
                    >
                      <StyledOption>
                        <OptionHeading>Option {index + 1}</OptionHeading>
                        <Field
                          name="paymentPlan"
                          component="input"
                          onChange={this._onChangePaymentPlan}
                          type="radio"
                          value={planItem.plan}
                          id={planItem.id}
                        />
                        <OptionLabel>
                          {planItem.type} <br />
                          licence fee
                        </OptionLabel>
                        <OptionList>
                          {this.displayIcons(...planItem.icons)}
                          <PlanButtonWrapper>
                            <StyledPlanButton type="button">
                              {paymentPlan === planItem.plan ? (
                                <React.Fragment>
                                  <img alt="tick-icon" src={TickIcon} />
                                  <SelectButtonText>Selected</SelectButtonText>
                                </React.Fragment>
                              ) : (
                                'Select plan'
                              )}
                            </StyledPlanButton>
                          </PlanButtonWrapper>
                        </OptionList>
                      </StyledOption>
                    </SuperStyledRadio>
                  ))}
                </SuperStyledRadioBox>
                <Field hideArrow name="paymentPlan" component={renderError} />
                <Field name="isAffordable" component="input" type="hidden" />
              </FormField>
              <TandCRibbon toggleTerms={this.toggleTerms} />
            </FieldCollection>
            {showGuarantor && ShowGurantorText(income)}
            <FieldCollection hasShadow>
              <Title>Were you referred by a member?</Title>
              <Field
                name="referralCode"
                type="text"
                component={renderField}
                label="Referral Code (Optional)"
                placeholder="Get your referral code from your friend"
              />
            </FieldCollection>
            <FieldCollection hasShadow>
              <Title>How did you discover The Collective?</Title>
              <Field
                name="discovery"
                type="text"
                component={renderField}
                required
                label=""
                placeholder="Please type.."
                validate={[required]}
              />
            </FieldCollection>
            <FieldCollection hasShadow>
              {deposit + fee !== 0 && (
                <NewFlex>
                  <NewTitle noMargin>Payment Details</NewTitle>
                  <PaymentOptions isWide />
                </NewFlex>
              )}
              {deposit + fee !== 0 && allow_cash && (
                <RadioBox>
                  <Field
                    name="paymentMethod"
                    onChange={this._onChangePaymentMethod}
                    component={renderRadio}
                    fixedValue="card"
                    label="Card payment"
                  />
                  <Field
                    name="paymentMethod"
                    onChange={this._onChangePaymentMethod}
                    component={renderRadio}
                    fixedValue="cash"
                    label="Pay in person"
                  />
                  <Field hideArrow name="paymentMethod" component={renderError} />
                </RadioBox>
              )}
              {showPayment && (
                <PaymentDetails
                  label="Card Details"
                  onCheckIt={this.checkIt}
                  onReady={paymentDetails => (this.paymentDetails = paymentDetails)}
                  amount={Number(deposit + fee) * 100}
                  attemptTCPIntent={!!this.state.readyForPayment}
                  onTCPaymentSuccess={this._onPaymentSuccess}
                  onTCPaymentError={this._onPaymentError}
                  locationId={locationId}
                  onGettingSecret={() => {
                    this.setState({ processingStep: 2 })
                  }}
                  fullName={
                    member.firstName && member.lastName
                      ? `${member.firstName} ${member.lastName}`
                      : ''
                  }
                />
              )}
              <StyledCheckbox>
                <Field name="terms" type="checkbox" component="input" />
                <Check id="terms" innerRef={node => (this.termsSection = node)} />
                <StyledP noPadding>
                  I have read and agree to the
                  <StyledButton type="button" onClick={evt => this.toggleTerms(evt)}>
                    <StyledA>terms & conditions</StyledA> {showTerms ? <ArrowUp /> : <ArrowDown />}
                  </StyledButton>
                </StyledP>
                <Field name="terms" component={renderError} />
              </StyledCheckbox>
              {showTerms && <PleaseNoteText />}
              <StyledP evenMoreMargin>
                By completing the application you agree to our{' '}
                <StyledA href="https://www.thecollective.com/privacy-notice/" target="_blank">
                  privacy policy{' '}
                </StyledA>
              </StyledP>
              <Button
                type="submit"
                uppercase
                makeDisabled={
                  this.state.checkButton ? this.isButtonDisabled() : this.isButtonDisabled()
                }
              >
                {`Complete application ${
                  deposit + fee !== 0 ? `& process payment of £${deposit + fee}` : ''
                }`}
              </Button>
              {isProcessing &&
                (showPayment ? (
                  <PaymentModal open={true} step={this.state.processingStep} />
                ) : (
                  <LoadingContainer>
                    <LoadingCircle />
                  </LoadingContainer>
                ))}
            </FieldCollection>
          </StyledForm>
          <BookingInfo
            booking={booking}
            paymentPlan={paymentPlan || 'monthly'}
            bookingDeposit={bookingDeposit}
            adminFee={adminFee}
          />
        </StyledArticle>
      </StyledFormPage>
    )
  }
}

const SecureRoomForm = reduxForm({
  form: 'secureRoom',
  validate
})(SecureRoomFormComponent)

export default SecureRoomForm



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/SecureRoomForm.js